import { render, staticRenderFns } from "./SettingScale.vue?vue&type=template&id=367280f2&scoped=true&"
import script from "./SettingScale.vue?vue&type=script&lang=js&"
export * from "./SettingScale.vue?vue&type=script&lang=js&"
import style0 from "./SettingScale.vue?vue&type=style&index=0&id=367280f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367280f2",
  null
  
)

export default component.exports